/**
 * Normalises a payment receipt value into a list of image URLs.
 *
 * The field has historically held a single URL string, while the mobile app
 * uploads several. Accept both — plus a JSON-encoded or comma-separated list —
 * so older records keep working alongside multi-image ones.
 */
export const toReceiptList = (raw) => {
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (raw === null || raw === undefined || raw === "") return [];
  const value = String(raw).trim();
  if (value.startsWith("[")) {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch (e) {
      // not JSON after all — fall through to the separator handling
    }
  }
  return value
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
};
